import React, { useEffect, useId } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import IconArrow from "assets/svg/chevron_right_black.svg";

import { Listbox } from "@headlessui/react";

import CheckBoxItem from "components/common/checkbox-item";
import Input from "components/common/input";

import styles from "./styles.module.css";

const CheckboxDropdown = ({
  placeHolder,
  options,
  buttonClass,
  listClass,
  disabled,
  handleDropdownButton,
  selectedItems = [],
  handleOptionChange,
  handleInputChange,
  inputValue,
  onOpenChange,
}) => {
  const dropdownClass = classNames({
    [styles.dropdown]: true,
    [buttonClass]: buttonClass,
  });

  const listClasses = classNames({
    [styles.list]: true,
    [listClass]: listClass,
  });

  const id = useId();

  const displaySelectedItems = () => {
    const textLength = 15;
    if (!selectedItems || selectedItems.length === 0) {
      return <span className={styles.placeholder}>{placeHolder}</span>;
    }

    let firstItem = selectedItems[0].name;
    if (firstItem.length > textLength) {
      firstItem = `${firstItem.substring(0, textLength)}...`;
    }

    if (selectedItems.length === 1) {
      return firstItem;
    } else {
      return `${firstItem} +${selectedItems.length - 1}`;
    }
  };

  const isChecked = (option) => selectedItems.some((selected) => selected.id === option.id);

  const handleKeyDown = (event) => {
    if (event?.key === " ") {
      event.stopPropagation();
    }
  };

  return (
    <Listbox value={selectedItems} multiple disabled={disabled}>
      {({ open }) => {
        useEffect(() => {
          onOpenChange(open);
        }, [open]);

        return (
          <>
            <Listbox.Button
              aria-expanded={open ? "true" : "false"}
              className={dropdownClass}
              onClick={handleDropdownButton}
            >
              <span className={styles.buttoncontent}>{displaySelectedItems()}</span>
              <span className={styles.icon}>
                <IconArrow />
              </span>
            </Listbox.Button>
            <Listbox.Options className={listClasses}>
              <div className={styles.filterInput}>
                <Input
                  value={inputValue}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDown}
                  placeholder={placeHolder}
                />
              </div>
              {options?.map((option, index) => (
                <Listbox.Option
                  key={`${id}+${index}`}
                  value={option.name}
                  className={({ active }) => `${styles.optionpadding} ${active && styles.optionselected}`}
                >
                  <CheckBoxItem
                    title={option.name}
                    name={option?.id}
                    onChange={(e) => handleOptionChange(option, e)}
                    checkBoxClass={option?.childs && styles.parentClass}
                    checked={isChecked(option)}
                  />
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </>
        );
      }}
    </Listbox>
  );
};

CheckboxDropdown.propTypes = {
  options: PropTypes.array,
  placeHolder: PropTypes.string,
  buttonClass: PropTypes.any,
  listClass: PropTypes.any,
  disabled: PropTypes.bool,
  handleDropdownButton: PropTypes.func,
  selectedItems: PropTypes.array,
  handleOptionChange: PropTypes.func,
  handleInputChange: PropTypes.func,
  inputValue: PropTypes.string,
  onOpenChange: PropTypes.func,
};

export default CheckboxDropdown;
